import { render, staticRenderFns } from "./paso2.vue?vue&type=template&id=e06a0312&scoped=true&"
import script from "./paso2.vue?vue&type=script&lang=ts&"
export * from "./paso2.vue?vue&type=script&lang=ts&"
import style0 from "./paso2.vue?vue&type=style&index=0&id=e06a0312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06a0312",
  null
  
)

export default component.exports